import Typography from '~components/dumbs/Typography'
import styled from 'styled-components'

export default styled(Typography).attrs({ as: 'p' })`
  font-weight: ${({ theme }) => theme.font.weight.medium};
  color: ${({ theme }) => theme.danger.text.default};
  margin-top: ${({ theme }) => theme.spacing.km1};
`
